export default "__VITE_ASSET__DXLyi8B3__"